import { Invoice } from '../entities/Invoice';

export const filterInvoiceList = (
  invoiceList: Invoice[],
  consumerUnitIdList: string[],
  utilityCompanyId: string,
  starRefMonth: string,
  endRefMonth: string
): Invoice[] => {
  let newInvoiceList = invoiceList.filter(
    (x) => x.refMonth >= starRefMonth && x.refMonth <= endRefMonth
  );

  // if (consumerUnitIdList.length) {
  //   newInvoiceList = newInvoiceList.filter((x) =>
  //     consumerUnitIdList.includes(x.consumerUnit.id),
  //   );
  // }

  if (utilityCompanyId !== 'all') {
    newInvoiceList = newInvoiceList.filter(
      (x) => x.consumerUnit.utilityCompany.id === utilityCompanyId
    );
  }

  return newInvoiceList;
};
